import styled from 'styled-components';
import { spacing, colors, Caption } from 'ui/theme';

export const TableCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const UlNoPadding = styled.ul`
  padding-left: 0;
  margin: 0;
`;

export const CaptionUnderline = styled(Caption)`
  color: ${colors.textSecondary};
  margin-bottom: 0;
  text-decoration: underline dashed ${colors.textSecondary};
  text-underline-offset: ${spacing.eighth};
`;
